import type { Form } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { DatePicker, type DatePickerDateType } from '../date-picker';
import { Item } from '../item';
import { disabledDate, disabledTime } from './disable';

type InputP = {
  'data-test-id'?: string;
  maximum?: Date;
  minimum?: Date;
} & ComponentProps<typeof DatePicker<DatePickerDateType>>;

type ItemP = {
  hidden?: boolean;
  label?: string;
} & Omit<ComponentProps<typeof Form.Item>, 'children' | 'label'>;

type P = {
  input?: InputP;
  item: ItemP;
};

const defaultInput: InputP = {};

export const DateTimePicker = ({ className, maximum, minimum, ...inputRest }: InputP) => (
  <DatePicker
    allowClear={false}
    className={cn(className, 'ui-date-time-input')}
    classNames={{ popup: { root: 'ui-date-time-input-popup' } }}
    disabledDate={disabledDate({ maximum, minimum })}
    disabledTime={disabledTime({ maximum, minimum })}
    needConfirm={false}
    showNow={false}
    {...inputRest}
  />
);

const DateTimeInput = ({ input: { fullWidth = true, ...inputRest } = defaultInput, item }: P) => (
  <Item {...item} label={item.label}>
    <DateTimePicker fullWidth={fullWidth} {...inputRest} />
  </Item>
);

export default DateTimeInput;

export type DateTimeInputItemProperties = ItemP;
